/**
 * Component Entry
 *
 */

import Slider from './Slider'
export default Slider
export * from './Slider'
